import { useTranslation } from 'react-i18next';
import { type DATE_FORMAT_RULE_NAME, getDateFormatKey } from '@/utils/datetime';
import cn from '@/utils/merge-class-names';

interface Props {
  timestamp: string | number | Date | undefined | null;
  ruleName: DATE_FORMAT_RULE_NAME;
  className?: string;
}

export default function DateDisplay({ timestamp, className, ruleName }: Props) {
  const { t } = useTranslation();

  if (!timestamp) return null;

  return <span className={cn('whitespace-nowrap', className)}>{getDateFormatKey(timestamp, ruleName, t)}</span>;
}
